<template>
  <ul class="my-note-category">
    <li @click="categoryChange(item.id)" :class="{'is_categort': item.id === isCategory}"
      v-for="item in categoryList" :key="item.id">{{item.value}}</li>
  </ul>
</template>
<script>
// import { getNotedDocuments } from '@/api/note.js'
export default {
  props: {
    category: Number
  },
  data () {
    return {
      categoryList: [
        {
          id: 0,
          value: '文献'
        },
        {
          id: 1,
          value: '指南'
        }
      ],
      isCategory: 0
    }
  },
  methods: {
    // // 获取有笔记的文章列表
    // async getNotedList () {
    //   const res = await getNotedDocuments({})
    //   this.isShow = res.data.length === 0
    //   this.list = res.data
    // },
    // // 跳转到笔记详情页
    // goNoteDetails (id) {
    //   this.$router.push({ path: '/noteDetails', query: { id } })
    // },
    categoryChange (categoryId) {
      this.isCategory = categoryId
      this.$emit('handle-category', categoryId)
    }
  },
  created () {
    this.isCategory = this.category || 0
    // this.getNotedList()
  }
}
</script>
<style lang="less" scoped>
.my-note-category {
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  margin-bottom: 8px;
  li {
    width: 90px;
    height: 100%;
    line-height: 30px;
    text-align: center;
    border-radius: 5px;
    background-color: #fff;
    margin-right: 30px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      background-color: #e8ecf6;
      color: #4b639f;
    }
  }
  .is_categort {
    background-color: #e8ecf6;
    color: #4b639f;
  }
}
</style>
